export default [
  {
    path: "/bece",
    children: [
      //students
      {
        path: "students",
        name: "beceStudents",
        component: () => import("@/views/bece/student/index.vue"),
        meta: {
          title: "STUDENTS",
          authRequired: true,
          acc: 'y13985'
        },
      },
      //students
      {
        path: "studentslsi",
        name: "beceStudentsList",
        component: () => import("@/views/bece/student/list.vue"),
        meta: {
          title: "Students list",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "view-student/:id",
        name: "beceStudent",
        component: () => import("@/views/bece/student/view.vue"),
        meta: {
          title: "VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student/:id",
        name: "beceEditStudent",
        component: () => import("@/views/bece/student/components/edit.vue"),
        meta: {
          title: "EDIT STUDENT",
        },
      },
      //register
      {
        path: "register",
        name: "bece-register",
        component: () => import("@/views/bece/register.vue"),
        meta: {
          title: "REGISTER",
        },
      },
      //Cas
      {
        path: "cas",
        name: "beceCas",
        component: () => import("@/views/bece/cas/index.vue"),
        meta: {
          title: "BECE CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "withca/:id",
        name: "beceWithCas",
        component: () => import("@/views/bece/cas/withca.vue"),
        meta: {
          title: "BECE With C.A",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "nonreg/:id?",
        name: "beceWithoutCas",
        component: () => import("@/views/bece/cas/withoutca.vue"),
        meta: {
          title: "BECE Without C.A",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "editca/:id?",
        name: "bece-editca",
        component: () => import("@/views/bece/cas/edit.vue"),
        meta: {
          title: "BECE UPDATE CA",
          authRequired: true,
          acc: 'y37962'
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "bece-photo_album",
        component: () => import("@/views/bece/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
        },
      },
      //gazette
      {
        path: "gazette",
        name: "bece-gazette",
        component: () => import("@/views/bece/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
        },
      },
      {
        path: "exam_card",
        name: "beceStudentsExamcard",
        component: () => import("@/views/bece/examcard.vue"),
        meta: {
          title: "EXAM CARD",
          authRequired: true,
          acc: 'y54282'

        },
      },
      //subject Analysis
      {
        path: "subject-analysis",
        name: "beceSubjectAnalysis",
        component: () => import("@/views/bece/subjectanalysis.vue"),
        meta: {
          title: "Subject Analysis",
        },
      },
      //Attendance
      {
        path: "exam-subjects",
        name: "beceExamSubject",
        component: () => import("@/views/bece/attendance/List.vue"),
        meta: {
          title: "Examination SUbject Attendance",
          authRequired: true,
        },
      },
      {
        path: "exam-attendance",
        name: "beceExamAttendance",
        component: () => import("@/views/bece/attendance/index.vue"),
        meta: {
          title: "Examination Attendance",
          authRequired: true,
        },
      },
    ],
  },
];
